// src/monaco-workers.ts
export function installMonacoWorkers() {
  if (typeof window === 'undefined') return; // SSR guard

  (self as any).MonacoEnvironment = {
    getWorker(_moduleId: string, label: string) {
      const mk = (p: string) =>
        new Worker(new URL(p, import.meta.url), { type: 'module' });

      switch (label) {
        case 'json':        return mk('monaco-editor/esm/vs/language/json/json.worker.js');
        case 'css':         return mk('monaco-editor/esm/vs/language/css/css.worker.js');
        case 'html':        return mk('monaco-editor/esm/vs/language/html/html.worker.js');
        case 'typescript':
        case 'javascript':  return mk('monaco-editor/esm/vs/language/typescript/ts.worker.js');
        default:            return mk('monaco-editor/esm/vs/editor/editor.worker.js');
      }
    }
  };
}